import { Component, computed, input } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

import { PlanSummary } from '../../../domain/lti/lti.domain';
import { GoalStatusType, GoalType } from '../../../domain/lti/lti.enum';
import { CurrencyPipe } from '../../../pipes/currency.pipe';

@Component({
  selector: 'td-wb-lti-plan-summary',
  templateUrl: 'plan-summary.component.html',
  styleUrls: ['plan-summary.component.scss'],
  imports: [
    TranslatePipe,
    TranslateDirective,
    CurrencyPipe
  ],
  host: {
    '[class.td-wb-plan-summary--center]': 'align() === \'center\''
  }
})

export class PlanSummaryComponent {
  readonly planSummary = input<PlanSummary>(undefined);
  readonly showProjectionAmount = input<boolean>(undefined);
  readonly align = input<'start' | 'center'>('center');
  private readonly targetAmountValue = computed(() => this.planSummary()?.targetAmount);
  private readonly projectedAmountValue = computed(() => this.planSummary()?.projectedAmount);
  private readonly titleValue = computed(() => this.planSummary()?.title ?? false);
  private readonly subTypeValue = computed(() => this.planSummary()?.subType);
  private readonly showSavingsValue = computed(() => {
    const summary = this.planSummary();
    if (!summary) {
      return false;
    }

    if (summary.subType === GoalType.BUILD_WEALTH) {
      return summary.targetAmount !== undefined;
    }

    return true;
  });

  private readonly superScriptValue = computed(() => this.titleValue() ? '' : '1');
  private readonly status = computed(() => this.planSummary()?.status);
  private readonly showSavingsPlan = computed(() => this.planSummary() !== undefined);

  get targetAmount(): number | undefined {
    return this.targetAmountValue();
  }

  get projectedAmount(): number | undefined {
    return this.projectedAmountValue();
  }

  get title(): boolean {
    return this.titleValue();
  }

  get subType(): GoalType | undefined {
    return this.subTypeValue();
  }

  get showSavings(): boolean {
    return this.showSavingsValue();
  }

  get superScript(): string {
    return this.superScriptValue();
  }

  showSavingPlanDescription(): boolean {
    return this.showSavingsPlan() && this.status() !== GoalStatusType.COMPLETE && !!this.showProjectionAmount();
  }
}

